'use client';

/**
 * @brisa/ui · facelift/bottom-nav-pill/BottomNavPillRouter
 *
 * Feature: mobile-tweaks-v2 · SPEC §7.8
 *
 * Client wrapper que injeta `currentPath` via Next.js `usePathname()`.
 * Mantém BottomNavPill apresentacional puro (Server-Component-friendly)
 * isolando a fronteira RSC/Client neste wrapper.
 */
import * as React from 'react';
import { usePathname } from 'next/navigation';

import { BottomNavPill, type BottomNavPillProps } from './BottomNavPill';

export type BottomNavPillRouterProps = Omit<BottomNavPillProps, 'currentPath'>;

export function BottomNavPillRouter(props: BottomNavPillRouterProps) {
  const pathname = usePathname();
  return <BottomNavPill currentPath={pathname ?? undefined} {...props} />;
}
